// extracted by mini-css-extract-plugin
export default {"container":"Kind_container__Ri9oe","box":"Kind_box__yTPSd"};